let languages = {
  'Search': 'Tìm kiếm',
  'You need input product name for search': 'Bạn cần nhập sản phẩm để tìm kiếm',
  'Confirm': 'Xác nhận',
  'We need your location for search result': 'Chúng tôi cần vị trí hiện tại của bạn để tìm kiếm',
  'Advantage search': 'Tìm kiếm nâng cao',
  'Central Location': 'Vị trí của bạn',
  'Distance(km)': 'Khoảng cách(KM)',
  'Everywhere': 'Mọi nơi',
  'Range': 'Phạm vi',
  'Welcome': 'Chào',
  'Settings': 'Cài đặt',
  'View your profile': 'Xem hồ sơ',
  'Logout': 'Đăng xuất',
  'Home': 'Trang chủ',
  'Please input your address': 'Vui lòng nhập địa chỉ của bạn',
  'No result': 'Không tìm thấy kết quả nào',
  'Updated feature image sucessfully': 'Cập nhật ảnh đại diện thành công',
  'Updated profile sucessfully': 'Cập nhật hồ sơ thành công',
  'Unable to search your location': 'Không thể tìm thấy vị trí địa chỉ của bạn',
  'Please wait': 'Vui lòng đợi',
  'Your address': 'Địa chỉ của bạn',
  'List products': 'Danh sách sản phẩm',
  'No product': 'Chưa có sản phẩm',
  'No information': 'Chưa có thông tin',
  'Set your address': 'Nhập địa chỉ của bạn',
  'Find gardens by product': 'Tìm vườn',
  'Find stores by product': 'Tìm cửa hàng',
  'Stores': 'Cửa hàng',
  'Gardens': 'Vườn',
  'List stores sell product': 'Danh sách cửa hàng bán sản phẩm',
  'List farmers plant product': 'Danh sách vườn trồng sản phẩm',
  'Certificate': 'Chứng nhận',
  'Cultivation method': 'Phương thức canh tác',
  'Store profile': 'Hồ sơ cửa hàng',
  'Store owner': 'Chủ cửa hàng',
  'Products available in store': 'Sản phẩm có sẵn ở cửa hàng',
  'Products available in garden': 'Sản phẩm có sẵn ở vườn',
  'Update Graden Info': 'Cập nhật hồ sơ vườn',
  'Update Store Info': 'Cập nhật hồ sơ cửa hàng',
  'View your garden profile': 'Xem hồ sơ vườn',
  'View your store profile': 'Xem hồ sơ cửa hàng',
  'Update store info': 'Cập nhật thông tin cửa hàng',
  'Select products that are available on your store': 'Chọn sản phẩm cửa hàng bạn có bán',
  'Input phone number': 'Nhập số điện thoại',
  'Input facebook': 'Đia chỉ Facebook',
  'Input youtube': 'Địa chỉ Youtube',
  'Get Your Location': 'Lấy địa chỉ hiên tại',
  'Please input your garden location': 'Vui lòng nhập địa chỉ vườn của bạn',
  'Please input your store location': 'Vui lòngs nhập địa chỉ cửa hàng của bạn',
  'Manage tracking': 'QL truy xuất',
  'Block': 'Khu vực',
  'Stamp': 'Tem',
  'Add block': 'Thêm khu vực',
  'Update block': 'Cập nhật khu vực',
  'Name': 'Tên',
  'Count Periods': 'Số lần trồng',
  'Action': 'Hành động',
  'Update': 'Cập nhật',
  'Delete': 'Xóa',
  'Prev': 'Trước',
  'Next': 'Sau',
  'List': 'Danh sách',
  'Print': 'In ấn',
  'Generate stamps': 'Tạo tem',
  'Code': 'Mã',
  'Harvest ID': 'Mã thu hoạch',
  'Search by code': 'Tìm kiếm theo code',
  'Available': 'Khả dụng',
  'Total': 'Tất cả',
  'From serial': 'Từ serial',
  'To serial': 'Tới serial',
  'Min': 'Tối thiểu',
  'Max': 'Tối đa',
  'Max item per print': 'Số lượng tối đa mỗi lần in',
  'Start date': 'Ngày bắt đầu',
  'Count Histories': 'Số lịch sử ',
  'Count Harvests': 'Số lần thu hoạch',
  'Add period': 'Thêm lần trồng',
  'Update period': 'Cập nhật lần trồng',
  'Add harvest': 'Thêm thu hoạch',
  'Date': 'Ngày',
  'Note': 'Ghi chú',
  'Add': 'Thêm',
  'Histories': 'Lịch sử',
  'Harvest': 'Thu hoạch',
  'Done by': 'Thực hiện bởi',
  'Description': 'Mô tả',
  'Variant Description': 'Mô tả loại sản phẩm',
  'Add history': 'Thêm lịch sử',
  'Please select one': 'Vui lòng chọn',
  'There is no data': 'Không có dữ liệu',
  'To serial can not smaller than from serial': 'Serial đầu không thể lớn hơn serial cuối',
  'From serial must greater than 0': 'Serial phải lớn hơn 0',
  'General list stamp': 'Tạo danh sách tem',
  'Number of stamps': 'Số lượng tem',
  'Do not input over': 'Không đươc nhập quá',
  'Available stamp do not over': 'Số lượng khả dụng không vượt quá',
  'ID': 'Mã',
  'Action name': 'Tên hành động',
  'You must input both information: from serial and to serial': 'Bạn phải nhập 2 thông tin đó: "từ serial" và "tới serial"',
  'Activity List': 'Nhật ký sản xuất',
  'Garden Info': 'Thông tin vườn',
  'Owner': 'Chủ',
  'Harvest Info': 'Thông tin thu hoạch',
  'QR Code': 'Mã QR',
  'Harvest Date': 'Ngày thu hoạch',
  'Page Not Found': 'Trang không tìm thấy',
  'Manage Periods': 'Quản lý lần trồng',
  'Manage Blocks': 'Quản lý khu vực',
  'Product': 'Sản phẩm',
  'More information about this product': 'Xem thông tin về sản phẩm',
  'Click here': 'Click ở đây',
  'History Detail': 'Chi tiết lịch sử',
  'Detail': 'Chi tiết',
  'Explanation': 'Giải thích',
  'Attached Photos': 'Ảnh đính kèm',
  'Upload photo': 'Upload ảnh',
  'There is no attach photo': 'Chưa có ảnh nào đính kèm',
  'Exceed maximum upload file size is 500kb': 'Dung lượng tôi đa cho phép là 500kb',
  'Only these file types are accepted': 'Chỉ các định dang ảnh sau được cho phép',
  'You can not update because of expired': 'Bạn không thể cập nhật vì hết hạn cho phép chỉnh sửa',
  'Invalid email or password': 'Email hoặc mật khẩu không hợp lệ',
  'Are you sure to remove this item ?': 'Bạn có chắc chắn muốn xóa mục này ?',
  'We need your email to keep in touch': 'Chúng tôi cần email của bạn để giữ liên lạc',
  'Password': 'Mật khẩu',
  'Login': 'Đăng nhập ',
  'Login via facebook': 'Đăng nhập qua Facebook',
  'OR': 'HOẶC',
  'Login Via Site': 'Đăng nhập qua trang web',
  'Almost Done': 'Gần xong rồi',
  'Sub Users': 'Tài Khoản Sale',
  'Address': 'Địa chỉ',
  'Phone': 'Số điện thoại',
  '10 digit begin with 0': '10 chữ số bắt đầu với 0',
  'Repeat Password': 'Nhập lại mật khẩu',
  'Add user': 'Thêm tài khoản',
  'Update user': 'Cập nhật tài khoản',
  'Only input password if you want to change password': 'Chỉ nhập mật khẩu nếu bạn muốn đổi mật khẩu',
  'Manage Sale Log': 'Quản lý lịch sử sale',
  'Add sale log': 'Thêm lịch sử sale',
  'Summary': 'Tóm lược',
  'Change Password': 'Đổi mật khẩu',
  'New password': 'Mật khẩu mới',
  'Confirm New password': 'Nhập lại mật khẩu mới',
  'Active new password via email': 'Lấy lại mật khẩu mới thông qua email',
  'Invalid code': 'Mã không hợp lệ',
  'New password have been change, Please use password in email to login and you can change it after logged in': 'Mật khẩu mới đã được đổi, vui lòng sử dụng mật khẩu trong email để đăng nhập và bạn có thể thay đổi sau khi đăng nhập thành công',
  'Forgot Password': 'Quên mật khẩu',
  'Request change password': 'Yêu cầu đổi mật khẩu',
  'Please check your email for instruction': 'Vui lòng kiểm tra email của bạn để làm theo hướng dẫn',
  'price_unit': 'đ',
  'Active': 'Bật',
  'Inactive': 'Tắt',
  'Status': 'Tình trạng',
  'Title': 'Tiêu đề ',
  'Area': 'Diện tích',
  'Price': 'Giá',
  'Purporse': 'Mục đích',
  'Province': 'Tỉnh',
  'Select your location on the map': 'Chọn địa chỉ của bạn trên bản đồ',
  'Manage My Land': 'Quản lý đất của tôi',
  'District': 'Huyện',
  'Commune': 'Xã',
  'Resources': 'Tài nguyên',
  'Electric': 'Điện',
  'Water': 'Nước',
  'Transport': 'Đường',
  'Select files to upload': 'Chọn ảnh để upload',
  'Buy': 'Mua',
  'Sell': 'Bán',
  'Lease': 'Thuê',
  'Cooperate': 'Hợp tác',
  'Update news': 'Cập nhật tin',
  'Add news': 'Thêm tin',
  'Enabled': 'Bật',
  'Disabled': 'Tắt',
  'Find land': 'Tìm đất',
  'Manage your post': 'Quản lý bài của bạn',
  'You need to update your phone to use this function': 'Bạn cần cập nhật số điện thoại trước khi sử dụng chức năng này',
  'The Mobile Number field is not in the correct format.': 'Số điện thoại là bắt buộc',
  'This phone is in used': 'Số phone này đã được sử dụng',
  'Click to see contact phone': 'Nhấn để xem số điện thoại',
  'Attached images': 'Ảnh đính kèm',
  'No': 'Không',
  'Yes': 'Có',
  'All provinces': 'Tât cả tỉnh',
  'All districts': 'Tât cả huyện',
  'All communes': 'Tât cả xã',
  'All prices (price_unit)': 'Tât cả giá (đ)',
  'All unit prices (price_unit)': 'Tất cả đơn giá (đ)',
  'All areas (m2)': 'Tât cả diện tích (m2)',
  'Buy/Sell': 'Mua/Bán',
  'All': 'Tất cả',
  'Under': 'Dưới',
  'Over': 'Trên',
  'Login success': 'Đăng nhập thành công',
  'Login fail': 'Đăng nhập thất bại, vui lòng thử lại',
  'Input name': 'Nhập tên',
  'Input certificate': 'Nhập chứng chỉ',
  'Input cultivation method': 'Nhập phương thức canh tác',
  'Select province': 'Chọn tỉnh',
  'Select district': 'Chọn huyện',
  'Select commune': 'Chọn xã',
  'You need update address in your profile before use this function': 'Bạn cần cập nhật địa chỉ trong hồ sơ của bạn trước khi sử dụng chức năng này',
  'Quantity (kg)': 'Số lượng (kg)',
  'Unit price (unit_price)/kg': 'Đơn giá (đ/kg)',
  'Total price (unit_price)': 'Tổng giá (đ)',
  'Location': 'Địa điểm',
  'Photos': 'Ảnh',
  'Enter description about product that you want to sell or buy': 'Thông tin về sản phẩm mà bạn muốn bán hoặc mua',
  'Product Name': 'Tên sản phẩm',
  'Post': 'Đăng',
  'Quantity': 'Số lượng',
  'Unit price': 'Đơn giá',
  'All products': 'Toàn bộ sản phẩm',
  'All quantity (kg)': 'Toàn bộ số lượng (kg)',
  'Remove': 'Xóa',
  'Are you sure to remove this photo ?': 'Bạn có chắc muốn xóa ảnh này không ?',
  'Search my post': 'Tìm bài của tôi',
  'You need login to post ad here': 'Bạn cần đăng nhập để đăng bài',
  'Market': 'Chợ',
  'Copied link': 'Đường dẫn đã được sao chép',
  'Copy link': 'Sao chép đường dẫn',
  'Payment': 'Thanh toán',
  'Are you sure to remove this ad ?': 'Bạn có chắc muốn xóa bài này ?',
  'Pre Transfer': 'Chuyển khoản trước',
  'Receive and transfer': 'Chuyển khoản sau',
  'Via vehicle': 'Thông qua xe',
  'Payment methods': 'Phương thức thanh toán',
  'Select': 'Chọn',
  'No history': 'Chưa có lịch sử',
  'Sale Market': 'Bán lẻ',
  'order': 'đơn hàng',
  'My order': 'Đơn hàng của tôi',
  'Favorited stores': 'Cửa hàng yêu thích',
  "User's order": 'Đơn hàng từ người dùng',
  'Amount': 'Số lượng',
  'View profile': 'Xem hồ sơ',
  'Add to favorite': 'Thêm vào yêu thích',
  'Order information': 'Thông tin đặt hàng',
  'Input email': 'Nhập email',
  'Estimate total price': 'Tổng tiền ước tính',
  'Place an order': 'Đặt hàng',
  'Please enter amount': 'Vui lòng nhập số lượng',
  'Your order is placed successfully': 'Đơn hàng của bạn được đặt thành công',
  'Waiting confirm': 'Đợi xác nhận',
  'Seller confirmed': 'Người bán đã xác nhận',
  'Delivering': 'Đang giao',
  'Finished': 'Hoàn thành',
  'Cancel': 'Hủy',
  'I received': 'Tôi đã nhận hàng',
  'Once the order is confirmed, You can not update total price. Are you sure to confirm this order ?': 'Khi đơn hàng đã xác nhận, bạn không thể cập nhật lại tổng giá cuối cùng ?',
  'Set delivery now': 'Đặt trang thái đơn hàng đang giao',
  'Are you sure to set this order is on delivery ?': 'Xác nhận đơn hàng đang giao ?',
  'Are you sure to set this order as finished ?': 'Xác nhận đơn hàng này đã nhận ?',
  'Updated total price by seller': 'Giá cập nhật bởi người bán',
  'Final price': 'Giá cuối cùng',
  'Estimated': 'Ước lượng',
  'Items': 'Mặt hàng',
  'Delivery info': 'Thông tin giao hàng',
  'Owner Profile': 'Hồ sơ chủ cửa hàng',
  'Store': 'Cửa hàng',
  'Remove from favorite': 'Xóa khỏi yêu thích',
  'My store': 'Cửa hàng của tôi',
  'Manage Stores': 'Quản lý cửa hàng',
  'Add store': 'Thêm cửa hàng',
  'Manage Sale Market': 'Quản lý bán lẻ',
  'Profile': 'Hồ sơ',
  'All varriants': 'Toàn bộ varriant',
  'All stores': 'Toàn bộ cửa hàng',
  'Add ad': 'Thêm tin',
  'Sale Market Dashboard': 'Quản lý bán lẻ',
  'View': 'Xem',
  'Update ad': 'Cập nhật tin',
  'Update store': 'Cập nhật cửa hàng',
  'Input store name': 'Nhập tên cửa hàng',
  'No varriant available': 'Không có varriant nào',
  'No order': 'Không có đơn hàng nào',
  'Update total price': 'Cập nhật thực giá',
  'My Profile': 'Hồ sơ của tôi',
  'My gardens': 'Vườn Của tôi',
  'Manage Gardens': 'Quản lý vườn',
  'Add garden': 'Thêm vườn',
  'Input garden name': 'Nhập tên vườn',
  'Garden is added': 'Vườn đã được thêm',
  'Update garden': 'Cập nhật vườn',
  'Your garden is updated': 'Vườn đã được cập nhật',
  'Garden': 'Vườn',
  'Or': 'Hoặc',
  'Register': 'Đăng ký',
  'Your phone is not valid': 'Số điện thoại của bạn không hợp lệ',
  'Your phone is not registed yet': 'Số điện thoại của bạn chưa đăng ký, vui lòng đăng ký để sử dụng',
  'Your phone already registed': 'Số điện thoại của bạn đã được đăng ký, Vui lòng sử dụng chức năng đăng nhập',
  'Count posts': 'Số bài viết',
  'There is no post': 'Không có bài viết nào',
  'All posts': 'Tất cả bài viết ',
  'Is Official': 'Toàn khoản chính thức ',
  'Keyword': 'Từ khóa',
  'Category': 'Chuyên mục',
  'Author': 'Tác giả',
  'Categories': 'Chuyên mục',
  'Register retailer': 'Đăng ký làm  nhà bán lẻ',
  'Update retailer': 'Cập nhật nhà bán lẻ',
  'Register farmer': 'Đăng ký làm nhà vườn',
  'Update farmer': 'Cập nhật nhà vườn',
  'Manage groups': 'Quản lý nhóm',
  'Image': 'Ảnh',
  'Feature Image': 'Ảnh Đại Diện',
  'Member': 'Thành viên',
  'My groups': 'Nhóm của tôi',
  'Add group': 'Thêm nhóm',
  'Input description': 'Nhập mô tả',
  'Update group': 'Cập nhật nhóm',
  'Manage member in group': 'Quản lý thành viên trong nhóm',
  'Delete from group': 'Xóa khỏi nhóm',
  'My Invitation': 'Lời mời',
  'Manage invitation': 'Quản lý lời mời',
  'Object': 'Đối tượng',
  'Mesage': 'Nội dung',
  'Accept': 'Chấp nhận',
  'Decline': 'Từ chối ',
  'Are you sure to agree this item ?': 'Bạn có chắc muốn đồng ý lời mời này  ?',
  'Are you sure to decline this item ?': 'Bạn có chắc muốn từ chối  lời mời này  ?',
  'Are you sure to invite this user to group ?': 'Bạn có chắc muốn mời thành viên này vào nhóm ?',
  'Your group is updated': 'Nhóm đã được cập nhật ',
  'Your group is added': 'Nhóm đã được thêm',
  'Update your profile': 'Cập nhật hồ sơ của bạn',
  'Member of group': 'Thành viên của nhóm',
  'Manage blocks': 'Quản lý khu vực',
  'Manage periods': 'Quản lý lần trồng',
  'Manage seasons': 'Quản lý mùa vụ',
  'Manage serials': 'Quản lý serial',
  'Garden name': 'Tên vườn',
  'Start year': 'Năm bắt đầu',
  'Count Seasons': 'Số mùa',
  'Finish date': 'Ngày kết thúc',
  'Seed quantity': 'Số lượng giống',
  'Estimate quantity': 'Ước lượng số lượng',
  'Period': 'Khu vực',
  'Add season': 'Thêm mùa',
  'Update season': 'Cập nhật mùa',
  'You need update phone before use this function': 'Bạn cần cập nhật hồ sơ của bạn trước khi sử dụng chức năng này ',
  'Updated info successfully': 'Cập nhật thông tin thành công',
  'Invitation is sent successfully': 'Đã gửi lời mời thành công',
  'groups': 'nhóm',
  'group': 'nhóm',
  'Input group name': 'Nhập tên nhóm',
  'Purchases History': 'Nhật ký mua bán',
  'Group Profile': 'Hồ sơ nhóm',
  'You need add more store before use this function': 'Bạn cần thêm cửa hàng trước khi sử dụng chức năng này',
  'farmer': 'Nhà vườn',
  'Farmer': 'Nhà vườn',
  'Provider': 'Nhà cung cấp ',
  'Buyer': 'Người mua',
  'Seller': 'Người bán',
  'Total Price': 'Tổng giá',
  'retailer': 'Nhà bán lẻ',
  'Retailer': 'Nhà bán lẻ',
  'Send': 'Gửi',
  'All buyers': 'Tất cả người mua',
  'All sellers': 'Tất cả người bán',
  'Select type': 'Chọn loại',
  'Buyer Order': 'Đơn mua',
  'Seller Order': 'Đơn bán',
  'Buyer Behaviour': 'Tư cách người mua',
  'Farmers/Group': 'Nhà vườn/ nhóm',
  'Add purchase': 'Thêm đơn hàng',
  'View purchase': 'Xem đơn hàng',
  'Update purchase': 'Cập nhật đơn hàng',
  'Are you sure to send this purchase and send to seller ?': 'Bạn có chắc chắn muốn gửi đơn hàng này cho người bán ?',
  'Are you sure to set this purchase is delivery to buyer ?': 'Bạn có chắc chắn cập nhật đã giao hàng cho người mua ?',
  'Are you sure to confirm this purchase to buyer ?': 'Bạn có chắc chắn xác nhận đơn hàng này từ người mua ?',
  'Are you sure to set this purchase is done ?': 'Bạn có chắc chắn xác nhân đã nhận hàng và kết thúc đơn hàng này ?',
  'Purchase Order Detail': 'Xem chi tiết đơn hàng',
  'Set as delivery': 'Xác nhận đã giao hàng',
  'Set as done': 'Xác nhận hoàn thành',
  'From Serial':	'Từ Serial',
  'To Serial':	'Đến  Serial',
  'Login/Register': 'Đăng nhập/ Đăng ký',
  'Add purchase detail': 'Thêm mặt hàng',
  'Update purchase detail': 'Cập nhật mặt hàng',
  'Select harvest': 'Chọn lần thu hoạch ',
  'Season': 'Mùa',
  'Report': 'Báo cáo',
  'Submit': 'Gửi',
  'Sending': 'Đang gửi',
  'All behaviors': 'Tất cả tư cách',
  'All types': 'Tất cả',
  'Order is updated': 'Đơn hàng đã được cập nhật',
  'List items': 'Danh sách mặt hàng',
  'All status': 'Tất cả trạng thái',
  'This email is existing': 'Email này đã tồn tại',
  'This phone is existing': 'Số điện thoại này đã tồn tại',
  'Register to be retailer': 'Đăng ký làm nhà bán lẻ',
  'Register to be farmer': 'Đăng ký làm nhà vườn',
  'Screet': 'Đường',
  'Residental': 'Thổ cư',
  'Paper': 'Giấy tờ',
  'Select any below certificate to continue': 'Chọn chứng chỉ bên dưới để tiếp tục',
  'Survey': 'Khảo sát',
  'Count questions': 'Số lượng câu hỏi',
  'Is converting': 'Đang chuyển đổi',
  'Residence area must be less than total area': 'Diện tích đất thổ cư phải nhỏ hơn diện tích tổng',
  'Store is added': 'Cửa hàng đã được thêm',
  'Your store is updated': 'Cửa hàng đã được cập nhật.',
  'Please accept location to show nearest store': 'Vui lòng cho phép chúng tôi lấy địa chỉ của bạn để hiển thị cửa hàng gần nhất',
  'Request Quotes': 'Yêu cầu báo giá',
  'Add quote': 'Thêm báo giá',
  'Your quote is added': 'Báo giá của bạn đã được thêm',
  'Your quote is update': 'Báo giá của bạn đã được cập nhật',
  'Shipping Address': 'Địa chỉ giao hàng',
  'View quote': 'Xem báo giá',
  'Input note': 'Nhập ghi chú ',
  'Input shipping address': 'Nhập địa chỉ giao hàng',
  'Register store': 'Đăng ký cửa hàng',
  'Manage store': 'Quản lý cửa hàng',
  'Manufacturers': 'Nguồn hàng',
  'Please accept to help us get your location': 'Vui lòng chấp nhận quyền lấy vị trí của bạn để chúng tôi hiển thị dữ liệu trả về  tốt hơn',
  'List referrals': 'Danh sách đã giới thiệu',
  'Warehouses': 'Kho',
  'Add warehouse': 'Thêm kho',
  'Register warehouse': 'Thêm kho',
  'There is no photo': 'Chưa có ảnh nào',
  'Your warehouse is added': 'Kho hàng của bạn đã được thêm',
  'Transport Vehicles': 'Xe hàng',
  'Manage transport vehicles': 'Quản lý xe hàng',
  'Add transport vehicle': 'Thêm xe hàng',
  'Update transport vehicle': 'Cập nhật xe hàng',
  'Payload': 'Trọng tải',
  'Your transport vehicle is updated': 'Xe hàng của bạn đã được cập nhật',
  'Your transport vehicle is added': 'Xe hàng của bạn đã được thêm',
  'Type': 'Loại',
  'Search by phone': 'Tìm theo số ĐT',
  'Business Type': 'Loại kinh doanh',
  'Input link': 'Nhập link',
  'Cold volume': 'Thể tích kho lạnh',
  'Input cold volume': 'Nhập thể tích kho lạnh',
  'Street': 'Số nhà, đường',
  'Input street': 'Nhập số nhà, đường',
  'Add route': 'Thêm tuyến',
  'Update route': 'Cập nhật tuyến',
  'Your transport vehicle route is added': 'Tuyến xe hàng của bạn đã được thêm',
  'Your transport vehicle route is updated': 'Tuyến xe hàng của bạn đã được cập nhật',
  'Find Transport Vehicles': 'Tìm tuyến xe'
}

module.exports = languages



// WEBPACK FOOTER //
// ./src/languages/vi.js